import React from 'react';

import BdsLoadingFullScreen from '../v3/BdsLoadingFullScreen/BdsLoadingFullScreen';
import './LoadingPage.scss';

const LoadingPage = () => {
  return (
    <div className="loading-page-container" data-experience="new">
      <BdsLoadingFullScreen show={true} text="" />
    </div>
  );
};

export default LoadingPage;
